/// <amd-module name="Search/WorkItem/Utils" />
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import * as Utils from "Search/Shared/Utils";
import { ResultsViewConstants } from "Search/WorkItem/Constants";
import { WorkItemField, WorkItemSearchRequest } from "Search/LegacyWebApi/Contracts/WorkItem";

export function getFieldValue(fields: WorkItemField[], fieldReferenceName: string): string {
    let fieldValue = fields.filter(field => localeIgnoreCaseComparer(field.referenceName, fieldReferenceName) === 0);
    return fieldValue[0] ? fieldValue[0].value : "";
}

export function sanitizeHtml(html: string): string {
    // replace multiple white spaces with a single white space.
    html = html.replace(ResultsViewConstants.WhiteSpaceRegex, " ");
    const encodedValue = Utils.htmlEncode(html);

    return encodedValue
        .replace(ResultsViewConstants.HitHighlightLightHtmlEncodedStartTagRegex, ResultsViewConstants.HighlightStartTag)
        .replace(ResultsViewConstants.HitHighlightLightHtmlEncodedEndTagRegex, ResultsViewConstants.HighlightEndTag);
}

export function areQueriesEqual(left: WorkItemSearchRequest, right: WorkItemSearchRequest): boolean {
    if (left.searchText !== right.searchText) {
        return false;
    }

    return Utils.areSortOptionsEqual(left.sortOptions, right.sortOptions)
        && Utils.areFiltersEqual(left.searchFilters, right.searchFilters);
}
